// Tracks stacked overlays (sheets, dialogs) so Escape only closes the
// topmost one, and body scroll unlocks only when the last overlay closes.
const stack: symbol[] = [];
let scrollLocks = 0;
let prevOverflow = "";

export function pushOverlay(id: symbol) {
  stack.push(id);
}

export function popOverlay(id: symbol) {
  const i = stack.indexOf(id);
  if (i >= 0) stack.splice(i, 1);
}

export function isTopOverlay(id: symbol) {
  return stack[stack.length - 1] === id;
}

export function lockBodyScroll() {
  if (scrollLocks === 0) {
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  scrollLocks++;
}

export function unlockBodyScroll() {
  scrollLocks = Math.max(0, scrollLocks - 1);
  if (scrollLocks === 0) {
    document.body.style.overflow = prevOverflow;
  }
}
